import React, { useState } from 'react';
import { Athlete } from '../atoms/athlete';
import { Button, Paper, Stack, TextField, Typography } from '@mui/material';
import Target from './Target';
import { useAtomValue } from 'jotai';
import { userAtom } from '../atoms/userAtom';
import UpdateTarget from './UpdateTarget';
import { Api } from '../providers/Api';

class Props {
    athlete: Athlete
    close: () => void;

}

const AddAthlete = (props: Props) => {
    const user = useAtomValue(userAtom);
    const [newFName, setNewFName] = useState(props.athlete.firstName);
    const [newLName, setNewLName] = useState(props.athlete.lastName);
    const [newNat, setNewNat] = useState(props.athlete.nationality);
    const [patternProne, setPatternProne] = useState(props.athlete.prone.pattern);
    const [patternStanding, setPatternStanding] = useState(props.athlete.standing.pattern);
    const { athlete } = props;
    if (athlete) {
        return <Paper style={{ padding: 20 }}>
                    <TextField value={newFName} onChange={(ev) => {setNewFName(ev.target.value);}}/>
                    <TextField value={newLName} onChange={(ev) => {setNewLName(ev.target.value);}}/>
            <Typography variant='h4'><TextField value={newNat} onChange={(ev) => {setNewNat(ev.target.value);}}/></Typography>
            <Typography variant='body2'>PRONE{athlete.prone && athlete.prone.name ? " (" + athlete.prone.name + ")" : ""}</Typography>
            
            <UpdateTarget isForNew updatePattern={(patt) => {setPatternProne(patt);}} pattern={athlete.prone?.pattern} cancel={() => {}} save={async (newPattern: string) => {
            
            }}/>            
                        
            <Typography variant='body2'>STANDING{athlete.standing && athlete.standing.name ? " (" + athlete.standing.name + ")" : ""}</Typography>

            <UpdateTarget isForNew updatePattern={(patt) => {setPatternStanding(patt);}} pattern={athlete.standing?.pattern} cancel={() => {}} save={async (newPattern: string) => {
                
            }}/>    

           <Button onClick={ async () => {
                let backend = new Api();
                athlete.nationality = newNat;
                athlete.firstName = newFName;
                athlete.lastName = newLName;
                athlete.standing.pattern = patternStanding;
                athlete.standing.name = new Date().toLocaleDateString();
                athlete.prone.pattern = patternProne;
                athlete.prone.name = new Date().toLocaleDateString();
                await backend.updateAthlete(athlete);
                props.close();
           }}>Save</Button> 
           <Button onClick={ async () => {
            props.close();
           }}>Cancel</Button> 
           
        </Paper>;
    }
    else {
        return null;
    }
}

export default AddAthlete;